import { h } from "omi";

import { IconProps } from "../icons";

export function NextWorkWhiteIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={props.width} height={props.height} viewBox="0 0 40 40">
      <g>
        <path
          fill={"white"}
          d="M11.2857 26.8711L6.8643 16.6354L2.44287 14.8711V29.9711L5.97144 31.3711L5.98573 21.9425L10.4 33.1282L14.8214 34.8711V19.7854L11.2857 18.3854V26.8711Z"
          shape-rendering="geometricPrecision"
        />
        <path
          fill={"white"}
          d="M39.7 7.52143H39.6929L20.4286 0L0 7.97857L19.9071 15.75C19.9071 15.75 19.9286 15.7571 19.95 15.7643V40L40 32.1714V7.64286L39.7 7.52857V7.52143ZM34.65 30.1071L31.4143 31.4L30.7357 26.3071L30.0571 31.95L26.8286 33.2429L24.45 20.15L27.1429 19.0714L28.6571 26.6786L29.6714 18.0571L31.7643 17.2214L32.7714 25L34.2857 16.2143L37.0357 15.1143L34.6571 30.1071H34.65Z"
          shape-rendering="geometricPrecision"
        />
      </g>
    </svg>
  );
}
